import { useEffect, useState } from 'react';
import axios from 'axios';
import { ReconciliationTransactionsRequest, ReconciliationTransactionsResponse } from 'vopay';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useFetchReconciliationTransactions() {
  const [loading, setLoading] = useState(false);
  const [source] = useState(() => axios.CancelToken.source());

  useEffect(() => {
    return () => source.cancel();
  }, [source]);

  const fetchReconciliationTransactions = async (
    requestParams: ReconciliationTransactionsRequest,
  ): Promise<ReconciliationTransactionsResponse> => {
    setLoading(true);
    try {
      const res = await api.fetchReconciliationTransactions(requestParams, source);
      return res;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    fetchReconciliationTransactions,
  };
}
